import axios from './axios';

export const characteristicsAPI = {
  // Get all characteristics
  getAll: async (searchableOnly = null) => {
    const params = {};
    if (searchableOnly !== null) {
      params.searchable_only = searchableOnly;
    }
    const response = await axios.get('/characteristics/', { params });
    return response.data;
  },

  // Get single characteristic
  getById: async (id) => {
    const response = await axios.get(`/characteristics/${id}`);
    return response.data;
  },

  // Create characteristic
  create: async (data) => {
    const response = await axios.post('/characteristics/', data);
    return response.data;
  },

  // Update characteristic
  update: async (id, data) => {
    const response = await axios.put(`/characteristics/${id}`, data);
    return response.data;
  },

  // Delete characteristic
  delete: async (id) => {
    await axios.delete(`/characteristics/${id}`);
  }
};
